import { Icon } from "@/components/atoms";
import { COLOR_CODE } from "@/utils/constants/colors";

const InfoItem = ({label, value, isHighlighted, icon}) => (
  <div className="col-span-1 pt-4">
    <div className="flex items-center gap-2">
      <span className="key text-sm" style={{color: COLOR_CODE._D0D0D0}}>
        {label}
      </span>
      {icon && <Icon alt={icon.alt} icon={icon.name} size={icon.size || 'small'} />}
    </div>
    <h2
      className="val text-base font-bold"
      style={isHighlighted ? {color: COLOR_CODE._3387DF} : {color: COLOR_CODE._FFFFFF}}
    >
      {value !== undefined && value !== null && value !== '' ? value : '-'}
    </h2>
  </div>
)

  export default InfoItem;